import { render, staticRenderFns } from "./AppSidebarNavLink.vue?vue&type=template&id=250ff95b&"
import script from "./AppSidebarNavLink.vue?vue&type=script&lang=js&"
export * from "./AppSidebarNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports